module.exports = __webpack_public_path__ + "static/media/vibe-filled-dark.d0aa3e91.svg";